export default "__VITE_PUBLIC_ASSET__2479c26e__"